import request from '@/utils/request'

/**
 * 获取应用列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listApps(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app.listApps',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加应用
 * @param {Object} data 应用数据
 * @returns {Promise} Promise对象
 */
export function saveApp(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app.saveApp',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新应用
 * @param {Object} data 应用数据
 * @returns {Promise} Promise对象
 */
export function updateApp(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app.updateApp',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除应用
 * @param {Object} data 应用数据
 * @returns {Promise} Promise对象
 */
export function deleteApp(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app.deleteApp',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}